import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { IconButton, ModalWindow } from '@/shared/ui'
import { PropType, ref } from 'vue'
import { SkillProgress } from '@/types'
import { useI18n } from 'vue-i18n'
import RollWindow from '@/features/RollSkillDice/RollWindow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RollSkillDice',
  props: {
	skill: {
		type: Object as PropType<SkillProgress>,
		required: true
	}
},
  setup(__props) {

const props = __props;

const i18n = useI18n()

const title = `${i18n.t('roll')}: ${i18n.t(`skill__${props.skill.name}`)}`
const modal = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IconButton), {
      hint: _ctx.$t('dice-roll'),
      type: "Dices",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (modal.value = true), ["stop"]))
    }, null, 8, ["hint"]),
    _createVNode(_unref(ModalWindow), {
      modelValue: modal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modal).value = $event)),
      title: title
    }, {
      default: _withCtx(() => [
        _createVNode(RollWindow, { skill: __props.skill }, null, 8, ["skill"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})